<template>
  <div class="LoginConnectionMode">
    <div class="LoginConnectionMode-modal">
      <span class="LoginConnectionMode-modal-title text is-size-7">{{
        $t('login.organization.mode')
      }}</span>

      <div class="LoginConnectionMode-modal-button">
        <button
          v-for="(method, index) in login_data.methods"
          :key="index"
          class="text is-size-8"
          @click="nextSteep(method)"
        >
          <div class="LoginConnectionMode-modal-button-title">
            {{ method[ssoTitle(method)] }}
          </div>

          <div>{{ method[ssoValue(method)] }}</div>
        </button>
      </div>

      <div class="LoginConnectionMode-modal-cancel">
        <button @click="$emit('close')">{{ $t('utils.action.cancel') }}</button>
      </div>
    </div>

    <div v-if="loading" class="LoginConnectionMode-loading">
      <img
        class="LayoutDefault-loading-img"
        src="@/assets/animations/loader-all.svg"
      />
    </div>
  </div>
</template>

<script>
'use strict'
import { mapGetters, mapMutations } from 'vuex'

import { ACTUAL_ROLE, MODE_SENDING_CODE } from '@/utils/consts'
import { getRoleByLocalStorage } from '@/utils/function'

export default {
  name: 'LoginConnectionMode',
  data() {
    return {
      MODE_SENDING_CODE: MODE_SENDING_CODE,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      login_data: 'auth/login_data'
    })
  },
  methods: {
    ...mapMutations('auth', ['SET_SSO_TYPE']),

    nextSteep(userMethode) {
      if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER) {
        this.SET_SSO_TYPE(userMethode.value) // set into sso_value the value of selected SSO
        this.$store
          .dispatch('auth/setLoginMethode', userMethode)
          .then(() => {
            this.$emit('close')
          })
          .catch(() => {
            this.$emit('close')
          })
      } else if (getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR) {
        this.$store
          .dispatch('auth/setLoginMethode', userMethode)
          .then(() => {
            this.$emit('close')
          })
          .catch(() => {
            this.$emit('close')
          })
        this.$store
          .dispatch('auth/sponsorLoginInfo')
          .then(() => {
            this.$emit('close')
          })
          .catch(() => {
            this.$emit('close')
          })
      }
    },
    ssoTitle(method) {
      return method.type === MODE_SENDING_CODE.SSO ? 'type' : 'name'
    },
    ssoValue(method) {
      return method.type === MODE_SENDING_CODE.SSO ? 'name' : 'value'
    }
  }
}
</script>

<style lang="scss">
.LoginConnectionMode {
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  padding: 1.5rem 0;
  transition-duration: 0.5s;
  margin-right: 1rem;

  &-bk {
    position: absolute;
    opacity: 0.4;
    width: 100%;
    height: 100%;
  }

  &-modal {
    z-index: 100;
    border-radius: 5px;
    padding: 0.5rem;
    background-color: $white;
    display: flex;
    flex-direction: column;
    width: 100%;

    &-cancel {
      display: flex;
      justify-content: center;
      margin-top: 1.5rem;

      > button {
        border: 1px solid $grey;
        border-radius: 5px;
        width: 70px;
        padding: 0.5rem;

        &:hover {
          background-color: $grey;
          color: $white;
        }
      }
    }

    &-title {
      text-align: center;
      padding: 1.2rem 3rem;
    }

    &-button {
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      > button {
        display: flex;
        justify-content: space-between;
        padding: 1.5rem 1rem;
        border-bottom: 1px solid $grey;

        &:hover {
          background-color: $hover-grey;
        }
      }

      &-title {
        text-transform: uppercase;
      }
    }
  }

  &-loading {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $light;
    opacity: 0.5;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 900;
  }
}
</style>
